import styled from 'styled-components'
import React, { FC } from 'react'
import { desktopSize, tabletSize } from '../screen-sizes'
import CornerTopRight from './assets/corner-top-right-big.png'
import CornerBottomLeft from './assets/corner-bottom-left-big.png'
import CornerTopRightSmall from './assets/corner-top-right.png'
import CornerBottomLeftSmall from './assets/corner-bottom-left.png'
import { HideBiggerThan, HideSmallerThan } from '../responsive/Hide'

interface BannerProps {}

export const LargeBanner: FC<BannerProps> = props => {
  let {} = props

  return (
    <Root data-cy={'large-banner'}>
      <HideBiggerThan limit={desktopSize}>
        <PaperTopRight src={CornerTopRightSmall} />
      </HideBiggerThan>
      <HideSmallerThan limit={desktopSize}>
        <PaperTopRight src={CornerTopRight} />
      </HideSmallerThan>
      <ZindexDiv>{props.children}</ZindexDiv>
      <HideBiggerThan limit={desktopSize}>
        <PaperBottomLeft src={CornerBottomLeftSmall} />
      </HideBiggerThan>
      <HideSmallerThan limit={desktopSize}>
        <PaperBottomLeft src={CornerBottomLeft} />
      </HideSmallerThan>
    </Root>
  )
}

const ZindexDiv = styled.div`
  z-index: 2;
`

const PaperTopRight = styled.img`
  position: absolute;
  top: 0;
  right: 0;
  border-top-right-radius: 35px;
`
const SmallPaperTopRight = styled.img`
  position: absolute;
  top: -50px;
  right: -50px;
`

const PaperBottomLeft = styled.img`
  position: absolute;
  bottom: 0;
  left: 0;
  border-bottom-left-radius: 35px;
`
const SmallPaperBottomLeft = styled.img`
  position: absolute;
  bottom: -50px;
  left: -50px;
`

const Root = styled.div`
  overflow: hidden;
  text-align: center;
  align-self: center;
  color: white;
  background-image: radial-gradient(
      circle at top left,
      rgba(93, 79, 221, 0.5),
      transparent
    ),
    radial-gradient(
      circle at bottom right,
      rgba(190, 175, 239, 0.5),
      transparent
    ),
    radial-gradient(circle at top right, rgba(1, 1, 61, 0.95) 20%, transparent),
    linear-gradient(140deg, #6863b9 10%, rgba(1, 1, 61, 0.95) 50%, #6863b9 90%);

  border-radius: 35px;
  padding: 0;
  display: flex;
  flex-direction: column;

  &::before {
  }

  @media (max-width: ${desktopSize}) {
    //    	width: 60%;
  }

  @media (max-width: ${tabletSize}) {
    //    	width: 95%;
  }
`
